import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeaderboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M21.0907 7.63636H15.9388V4.90909C15.9388 4.66798 15.8431 4.43675 15.6726 4.26627C15.5021 4.09578 15.2709 4 15.0298 4H8.96976C8.72865 4 8.49742 4.09578 8.32693 4.26627C8.15644 4.43675 8.06067 4.66798 8.06067 4.90909V11.2727H2.90885C2.66774 11.2727 2.43651 11.3685 2.26602 11.539C2.09553 11.7095 1.99976 11.9407 1.99976 12.1818V19.4545C1.99976 19.6957 2.09553 19.9269 2.26602 20.0974C2.43651 20.2679 2.66774 20.3636 2.90885 20.3636H21.0907C21.3318 20.3636 21.563 20.2679 21.7335 20.0974C21.904 19.9269 21.9998 19.6957 21.9998 19.4545V8.54545C21.9998 8.30435 21.904 8.07312 21.7335 7.90263C21.563 7.73214 21.3318 7.63636 21.0907 7.63636ZM8.06067 18.8593H3.49976V12.7695H8.06067V18.8593ZM14.4373 18.8593H9.56226V5.5H14.4373V18.8593ZM20.4998 18.8593H15.9388V9.13672H20.4998V18.8593Z",
		fill: "#000"
	})]
});
const ForwardRef = forwardRef(SvgLeaderboard);
export { ForwardRef as ReactComponent };
